"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { logoutDemo } from "./actions";

type Session = {
  authenticated: boolean;
  name?: string;
  canManageEvents?: boolean;
};

export function SessionNav() {
  const [session, setSession] = useState<Session | null>(null);
  const pathname = usePathname();

  useEffect(() => {
    fetch("/api/session", { cache: "no-store" })
      .then((response) => response.json())
      .then(setSession)
      .catch(() => setSession({ authenticated: false }));
  }, [pathname]);

  return (
    <nav aria-label="Navegación principal">
      <Link
        aria-current={pathname === "/home" ? "page" : undefined}
        href="/home"
      >
        Cartelera
      </Link>
      {session?.authenticated ? (
        <>
          <Link
            aria-current={
              pathname.startsWith("/dashboard") ? "page" : undefined
            }
            href="/dashboard"
          >
            Inicio
          </Link>
          {session.canManageEvents ? (
            <Link
              aria-current={
                pathname.startsWith("/mis-eventos") ||
                pathname.startsWith("/eventos")
                  ? "page"
                  : undefined
              }
              href="/mis-eventos"
            >
              Mis eventos
            </Link>
          ) : null}
          <Link
            aria-current={
              pathname.startsWith("/mis-entradas") ? "page" : undefined
            }
            href="/mis-entradas"
          >
            Mis entradas
          </Link>
          <Link
            aria-current={pathname === "/perfil" ? "page" : undefined}
            href="/perfil"
          >
            Mi perfil
          </Link>
          <form action={logoutDemo}>
            <button className="nav-button" type="submit">
              Cerrar sesión
            </button>
          </form>
        </>
      ) : (
        <Link href="/login">Iniciar sesión</Link>
      )}
    </nav>
  );
}
